module.exports = __webpack_public_path__ + "static/img/4.8be8d97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/4.png
// module id = hNnL
// module chunks = 0